module.exports = __webpack_public_path__ + "img/boldIcon.17c159f7.svg";